import { render, staticRenderFns } from "./Leituras.vue?vue&type=template&id=2867a176&"
import script from "./Leituras.vue?vue&type=script&lang=js&"
export * from "./Leituras.vue?vue&type=script&lang=js&"
import style0 from "./Leituras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports